<template>
	<div class="form-horizontal">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<div class="col-md-12 form-group-inline" v-bind:class="{ 'is-invalid': errors.has('Tanggal Pengangkutan')}">
						<label class="col-form-label col-md-3">Tanggal Pengangkutan</label>
						<div class="col-md-3">
							{{models.tglAngkut | formatDate}}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Dari Lokasi Penyimpanan</label>
						<div class="col-md-9">
							{{  models.Skala  }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Kota</label>
						<div class="col-md-9" v-if="models.fasilitasB3TPS">
							{{  models.fasilitasB3TPS.kota ? models.fasilitasB3TPS.kota.namaKota : ""  }}
						</div>
					</div>

					<div v-if="models.Skala == 'kecamatan'" class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Kecamatan</label>
						<div class="col-md-9" v-if="models.fasilitasB3TPS">
							{{  models.fasilitasB3TPS.kecamatan ? models.fasilitasB3TPS.kecamatan.namaKecamatan : ""  }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Jenis Fasilitas</label>
						<div class="col-md-9">
							{{ models.JenisFasilitas == '5' ? 'FPSSB3 Kecamatan' : 'FPSSB3 Kota' }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Fasilitas B3</label>
						<div class="col-md-9" v-if="models.fasilitasB3TPS">
							{{  models.fasilitasB3TPS.namaFasilitas }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Alamat Fasilitas B3</label>
						<div class="col-md-9" v-if="models.fasilitasB3TPS">
							{{  models.fasilitasB3TPS.alamatFasilitas }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Unit (Suku Dinas)</label>
						<div class="col-md-9" v-if="models.pihak3">
							{{  models.pihak3.sudin ? models.pihak3.sudin.namaSudin : "" }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Pihak Tiga</label>
						<div class="col-md-9" v-if="models.pihak3">
							{{ models.pihak3.namaPihak3 }}
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Rincian</label>
						<div class="col-md-9">
							<table class="table b-table">
								<thead>
									<tr>
										<th width="55%">Kode Limbah</th>
										<th width="30%">Tonase (Kg)</th>
									</tr>
								</thead>
								<tbody>
									<template v-if="models.rincianAngkuts.length">
										<tr v-for="(v, k) in models.rincianAngkuts">
											<td>
												{{ v.limbahB3 ? v.limbahB3.kodeLimbah : "" }} - {{ v.limbahB3 ? v.limbahB3.namaLimbah : "" }}
											</td>
											<td>
												{{  v.beratTonase  }}
											</td>
										</tr>
									</template>
									<tr v-else>
										<td colspan="2" align="center">
											Tidak Ada Data
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Upload Manifes (PDF)</label>
						<div class="col-md-9">
							<p v-if="models.manifest">
								<a :href="config.asset_url + models.manifest" target="_blank">Lihat File</a>
							</p>
						</div>
					</div>
                    <div class="col-md-12 form-group-inline">
						<label class="col-form-label col-md-3">Status Verifikasi</label>
						<div class="col-md-9">
							<span :class="'badge badge-' + getB3StatusClass(models.isVerified)">{{ getB3Status(models.isVerified) }}</span>
						</div>
					</div>
				</b-row>
				<template #footer>
                    <template v-if="(models.isVerified == null || models.isVerified == 0) && config.roleUser == 'Super Admin'">
                       <b-button type="button" variant="danger" @click="updateStatusVerify('2')" class="btn-min-width float-right">
                            Revisi
                        </b-button>
                        <b-button type="button" variant="primary"  @click="updateStatusVerify('1')" class="btn-min-width float-right">
                            Verifikasi
                        </b-button>
                    </template>
                    <b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</div>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import moment from 'moment';
	import { getB3Status, getB3StatusClass } from '@/utils/helpers';

	export default {
		name: 'ViewLimbahB3Terkelola',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
					roleUser: "",
					asset_url: process.env.VUE_APP_ASSET
				},
				models: {
					rincianAngkuts: [],
				},
				FormData: new FormData(),
			}
		},
		created() {
			const _ = this
			_.getById();
			_.getRoleUser();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`LimbahB3Terkelola/${_.$route.params.id}`);
						_.models = request.data.data;
                        _.models.Skala = 'kota';
						_.models.JenisFasilitas = "6";
						if(_.models.fasilitasB3TPS){
							if(_.models.KecamatanId = _.models.fasilitasB3TPS.kecamatanId){
								_.models.Skala = 'kecamatan';
								_.models.JenisFasilitas = "5";
							}
						}
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			async getRoleUser() {
				const _ = this;
				const request = await _.$axios.get(`Authentication/me`);
				if(request){
					let user = request.data.data;
					_.config.roleUser = user.userRoles.length ? user.userRoles[0].roleName : "";
				}
			},
            getB3Status(status) {
				return getB3Status(status);
			},
			getB3StatusClass(status) {
				return getB3StatusClass(status);
			},
            updateStatusVerify(code) {
				const _ = this;
				_.$dialog.confirm('Anda yakin akan mengubah status verifikasi data ini?', {
					"okText": "Ya",
					"cancelText": "Tidak"
				}).then(() => {
                    _.FormData = new FormData();
                    _.FormData.append('id', _.models.id);
                    _.FormData.append('IsVerified', String(code));
					_.$axios.put(`LimbahB3Terkelola/${_.$route.params.id}/verify`, _.FormData)
					.then(res => {
						_.$refs.response.setResponse(res.data.message, 'success');
						_.getById();
					})
				}).catch((error) => _.$refs.response.setResponse(error.response.data.message, 'danger'));
			},
		}
	}
</script>